class TestCaseCreator {
    static add(name, testCaseConstructor) {
        TestCaseCreator._testCaseClassMap.set(name, testCaseConstructor);
    }
    static createTestCase(testCaseData) {
        const testCaseClass = TestCaseCreator._testCaseClassMap.get(testCaseData.className);
        if (testCaseClass != null) {
            return new testCaseClass(testCaseData.parameterData);
        }
        else {
            throw new Error("Could not find TestCase Class : " + testCaseData.className);
        }
    }
    static createTestCases(testCaseDatas) {
        const testCases = new Array();
        for (const testCaseData of testCaseDatas) {
            testCases.push(TestCaseCreator.createTestCase(testCaseData));
        }
        return testCases;
    }
}
TestCaseCreator._testCaseClassMap = new Map();
export { TestCaseCreator };
